import { Stack, Text } from '@/theme/index';
import { scrollToElement } from '@/utils/index';
import { StyledCard } from '../components';

interface VehicleReportInfoCardProps {
  index: number;
  showButtonView?: boolean;
  card: {
    icon: JSX.Element;
    text: string;
    link: string;
    subText?: string;
  };
  handleFreeUpgrade: () => void;
}

export const VehicleReportInfoCard = ({
  index,
  showButtonView,
  card,
  handleFreeUpgrade,
}: VehicleReportInfoCardProps) => {
  const handleRedirect = () => {
    if (showButtonView) {
      handleFreeUpgrade();
      return;
    }

    scrollToElement(card.link);
  };

  return (
    <StyledCard
      key={index}
      onClick={handleRedirect}
      data-testid="vehicle-report-info-card-overview"
    >
      <Stack direction="column" alignItems="center">
        {card.icon}
        <Stack
          py={1}
          px={2}
          mt={showButtonView ? 1.5 : 1}
          sx={{
            border: `${showButtonView ? '1px solid grey' : 'none'}`,
            borderRadius: 5,
          }}
        >
          <Text
            variant="body2"
            fontSize="0.8125rem"
            fontWeight="bold"
            textAlign="center"
          >
            {card.text}
          </Text>
          {card.subText && (
            <Text fontSize="0.75rem" color="text.secondary" textAlign="center">
              {card.subText}
            </Text>
          )}
        </Stack>
      </Stack>
    </StyledCard>
  );
};
